(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('naturita-header-menu')) {
    customElements.define('naturita-header-menu', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.cleanups = [];
        const signal = this.controller.signal;
        const desktop = window.matchMedia('(min-width: 990px)');
        const hover = window.matchMedia('(hover: hover) and (pointer: fine)');
        const groups = [...this.querySelectorAll('[data-naturita-shop]')];
        const mobile = this.querySelector('[data-naturita-mobile]');
        const mobileToggle = mobile?.querySelector('[data-naturita-mobile-toggle]');
        const mobilePanel = mobile?.querySelector('[data-naturita-mobile-panel]');
        const mobileIsOpen = () => Boolean(mobile?.classList.contains('is-open'));

        // Fit the open menu below the actual header, including a wrapped announcement.
        const updateMobileSpace = () => {
          if (!mobileIsOpen()) return;
          const bottom = this.getBoundingClientRect().bottom;
          if (bottom > 0) this.style.setProperty('--naturita-menu-top', `${Math.ceil(bottom)}px`);
        };
        window.addEventListener('resize', updateMobileSpace, { signal });
        window.addEventListener('scroll', updateMobileSpace, { signal, passive: true });
        if ('ResizeObserver' in window) {
          const sizeObserver = new ResizeObserver(updateMobileSpace);
          sizeObserver.observe(this);
          this.cleanups.push(() => sizeObserver.disconnect());
        }

        const setMobileOpen = (open, returnFocus = false) => {
          if (!mobile) return;
          mobile.classList.toggle('is-open', open);
          mobileToggle?.setAttribute('aria-expanded', String(open));
          mobileToggle?.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
          mobilePanel?.setAttribute('aria-hidden', String(!open));
          document.documentElement.classList.toggle('naturita-menu-open', open);
          if (open) requestAnimationFrame(updateMobileSpace);
          if (returnFocus) mobileToggle?.focus();
        };
        const closeMobile = (returnFocus = false) => setMobileOpen(false, returnFocus);
        this.cleanups.push(() => document.documentElement.classList.remove('naturita-menu-open'));

        groups.forEach(group => {
          const details = group.querySelector('[data-naturita-disclosure]');
          const toggle = details.querySelector('summary');
          const panel = group.querySelector('.figma-header-custom__mega');
          const link = group.querySelector('.figma-header-custom__shop-link');
          let openTimer;
          let closeTimer;
          let pointerInside = false;
          const clearTimers = () => { clearTimeout(openTimer); clearTimeout(closeTimer); };
          const close = () => { clearTimers(); details.open = false; };
          this.cleanups.push(clearTimers);

          group.addEventListener('pointerenter', event => {
            if (!desktop.matches || !hover.matches || event.pointerType !== 'mouse') return;
            pointerInside = true;
            clearTimers();
            openTimer = setTimeout(() => {
              groups.forEach(other => { if (other !== group) other.querySelector('details').open = false; });
              details.open = true;
            }, 90);
          }, { signal });
          group.addEventListener('pointerleave', event => {
            if (event.pointerType !== 'mouse') return;
            pointerInside = false;
            clearTimers();
            closeTimer = setTimeout(() => {
              if (!panel.contains(document.activeElement) && document.activeElement !== toggle) close();
            }, 140);
          }, { signal });
          toggle.addEventListener('click', clearTimers, { signal });
          group.addEventListener('focusout', () => {
            queueMicrotask(() => { if (!group.contains(document.activeElement) && !pointerInside) close(); });
          }, { signal });
          group.addEventListener('keydown', event => {
            if (event.key === 'Escape' && details.open) {
              event.preventDefault();
              event.stopPropagation();
              close();
              toggle.focus();
            } else if (event.key === 'ArrowDown' && (event.target === link || event.target === toggle)) {
              event.preventDefault();
              clearTimers();
              details.open = true;
              panel.querySelector('a')?.focus();
            }
          }, { signal });
          document.addEventListener('click', event => { if (!group.contains(event.target)) close(); }, { signal });
          document.addEventListener('keydown', event => {
            // A menu opened by hover must also dismiss when keyboard focus is elsewhere.
            if (event.key === 'Escape' && details.open && !group.contains(event.target)) close();
          }, { signal });
          desktop.addEventListener('change', close, { signal });
        });

        mobileToggle?.addEventListener('click', () => {
          setMobileOpen(!mobileIsOpen());
        }, { signal });
        mobile?.addEventListener('keydown', event => {
          if (event.key !== 'Escape' || !mobileIsOpen()) return;
          event.preventDefault();
          event.stopPropagation();
          closeMobile(true);
        }, { signal });
        document.addEventListener('click', event => {
          if (mobileIsOpen() && !mobile.contains(event.target)) closeMobile();
        }, { signal });
        // Do not close on focusout: touch browsers can blur the summary before
        // dispatching the tapped link's click. Hiding it then cancels navigation.
        // Native links complete normally; outside clicks and Escape close the menu.
        desktop.addEventListener('change', () => closeMobile(), { signal });

        // Listen to cart updates without intercepting requests or changing the cart drawer.
        const refreshCart = () => {
          clearTimeout(this.cartTimer);
          this.cartTimer = setTimeout(async () => {
            try {
              const response = await fetch(this.dataset.cartUrl, { headers: { Accept: 'application/json' }, signal });
              if (!response.ok) return;
              const cart = await response.json();
              if (!Number.isInteger(cart.item_count) || !this.isConnected) return;
              this.querySelectorAll('[data-naturita-cart-count]').forEach(badge => {
                badge.textContent = String(cart.item_count);
                badge.hidden = cart.item_count === 0;
              });
              this.querySelectorAll('[data-naturita-cart]').forEach(link => {
                link.setAttribute('aria-label', `Cart, ${cart.item_count} ${cart.item_count === 1 ? 'item' : 'items'}`);
              });
            } catch (error) {
              // Keep the server-rendered count if a cart refresh cannot complete.
            }
          }, 100);
        };
        ['cart:update', 'cart:updated', 'cart:change'].forEach(name => document.addEventListener(name, refreshCart, { signal }));
        window.addEventListener('pageshow', event => { if (event.persisted) refreshCart(); }, { signal });
        this.querySelectorAll('[data-naturita-cart]').forEach(link => {
          link.addEventListener('pointerenter', refreshCart, { signal });
          link.addEventListener('focus', refreshCart, { signal });
        });
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.cleanups?.forEach(cleanup => cleanup());
        document.documentElement.classList.remove('naturita-menu-open');
        clearTimeout(this.cartTimer);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
